import './Form.scss'
import { userApi } from '../../redux/services/userApi';
import { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ILoginUser } from '../../models/ILoginUser';
import svg from "../../assets/img/sprite.svg";
import { LoginFormProps } from '../FormModal/LogRegModal';



export const LoginForm: FC<LoginFormProps> = ({ setLogRegModal }) => {

    const [loginUser, { isSuccess, isLoading, isError }] = userApi.useLoginUserMutation()
    const [onPass, setOnPass] = useState(false)

    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues: {
            email: '',
            password: '',
        }
    })

    const onSubmit = async (data: ILoginUser) => {
        await loginUser(data)
    }

    useEffect(() => {
        if (isError) {
            alert('Ошибка входа. Неверный email или пароль.');
        }
        else if (isSuccess) {
            setLogRegModal(false);
        }
    }, [isSuccess, isError, setLogRegModal]);

    return (
        <>
            <form className='form' onSubmit={handleSubmit(onSubmit)}>
                <div className='form__block'>
                    <label className={errors.email ? "form__label error" : "form__label"}>
                        <svg className="form__icon" width="22" height="19" fill="none">
                            <use xlinkHref={`${svg}#email`}></use>
                        </svg>
                        <input className='form__input' type="email" placeholder="Электронная почта" {...register('email', {
                            required: 'Поле не заполнено'
                        })} />
                    </label>
                    <label className={errors.password ? "form__label error" : "form__label"}>
                        <svg onClick={() => setOnPass(!onPass)} className={onPass ? "form__icon on form__icon_key" : "form__icon form__icon_key"} width="24" height="25" fill="none">
                            <use xlinkHref={`${svg}#key`}></use>
                        </svg>
                        <input className='form__input' type={onPass ? "text" : "password"} placeholder="Пароль" {...register('password', {
                            required: 'Поле не заполнено',
                        })} />
                    </label>
                </div>
                <button disabled={isLoading} className='form__btn btn btn-blue'>Войти</button>
            </form >
        </>
    )
}


